(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-cz-faq-preview]';
  var ITEM_SELECTOR = '[data-cz-faq-item]';
  var CATEGORY_SELECTOR = '[data-cz-faq-category]';
  var NAV_SELECTOR = '[data-cz-faq-nav]';
  var QUESTION_SELECTOR = '[data-cz-faq-question-trigger]';
  var TABLET_QUERY = '(max-width: 1050px)';
  var REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

  function normalizeText(value) {
    var normalized = String(value || '');

    if (typeof normalized.normalize === 'function') {
      normalized = normalized.normalize('NFKD');
    }

    return normalized
      .replace(/[\u0300-\u036f]/g, '')
      .toLocaleLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .replace(/\s+/g, ' ');
  }

  function wordsFor(value) {
    var normalized = normalizeText(value);
    return normalized ? normalized.split(' ') : [];
  }

  function hasWordPrefixes(words, queryWords) {
    return queryWords.every(function (queryWord) {
      return words.some(function (word) {
        return word === queryWord || word.indexOf(queryWord) === 0;
      });
    });
  }

  function numericOrder(item) {
    var rawOrder = item.getAttribute('data-cz-faq-order');
    var order = rawOrder === null || rawOrder.trim() === '' ? NaN : Number(rawOrder);
    return Number.isFinite(order) ? order : Number.MAX_SAFE_INTEGER;
  }

  function pluralize(count, singular, plural) {
    return count + ' ' + (count === 1 ? singular : plural);
  }

  function initFaq(root) {
    if (!root || root.getAttribute('data-cz-faq-initialized') === 'true') return;
    root.setAttribute('data-cz-faq-initialized', 'true');

    var searchForm = root.querySelector('[data-cz-faq-search]');
    var searchInput = root.querySelector('[data-cz-faq-input]');
    var searchResults = root.querySelector('[data-cz-faq-results]');
    var searchStatus = root.querySelector('[data-cz-faq-status]');
    var clearButton = root.querySelector('[data-cz-faq-clear]');
    var topicIndex = root.querySelector('[data-cz-faq-index]');
    var topicNav = topicIndex ? topicIndex.querySelector('nav') : null;
    var categories = Array.prototype.slice.call(root.querySelectorAll(CATEGORY_SELECTOR));
    var navLinks = Array.prototype.slice.call(root.querySelectorAll(NAV_SELECTOR));
    var reduceMotion = window.matchMedia(REDUCED_MOTION_QUERY);
    var tabletLayout = window.matchMedia(TABLET_QUERY);
    var cleanupTasks = [];
    var resultButtons = [];
    var currentMatches = [];
    var activeResultIndex = -1;
    var activeCategoryId = '';
    var viewportFrame = 0;
    var stickyTop = 24;

    function listen(target, eventName, listener, options) {
      if (!target) return;
      target.addEventListener(eventName, listener, options);
      cleanupTasks.push(function () {
        target.removeEventListener(eventName, listener, options);
      });
    }

    function sortCategoryItems(category) {
      var items = Array.prototype.slice.call(category.querySelectorAll(ITEM_SELECTOR));
      if (!items.length) return;

      var sortableItems = items.map(function (item, index) {
        return {
          item: item,
          shell: item.closest('.cz-faq-item-shell') || item,
          index: index,
          order: numericOrder(item)
        };
      });
      var parent = sortableItems[0].shell.parentElement;
      if (!parent) return;

      sortableItems
        .sort(function (first, second) {
          if (first.order !== second.order) return first.order - second.order;
          return first.index - second.index;
        })
        .forEach(function (record) {
          if (record.shell.parentElement === parent) parent.appendChild(record.shell);
        });
    }

    categories.forEach(sortCategoryItems);

    var entries = Array.prototype.slice.call(root.querySelectorAll(ITEM_SELECTOR)).map(function (item, index) {
      var questionNode = item.querySelector(QUESTION_SELECTOR);
      var categoryNode = item.closest(CATEGORY_SELECTOR);
      var headingNode = categoryNode ? categoryNode.querySelector('h2') : null;
      var answerNode = item.querySelector('.cz-faq-answer');
      var question = item.getAttribute('data-cz-faq-question') || (questionNode ? questionNode.textContent : '');
      var category = item.getAttribute('data-cz-faq-category-name') || (headingNode ? headingNode.textContent : '');
      var answer = answerNode ? answerNode.textContent : '';
      var questionWords = wordsFor(question);
      var categoryWords = wordsFor(category);
      var answerWords = wordsFor(answer);

      if (!item.id) item.id = 'cz-faq-item-' + (index + 1);

      return {
        item: item,
        questionNode: questionNode,
        categoryNode: categoryNode,
        question: String(question).trim(),
        category: String(category).trim(),
        questionNormalized: normalizeText(question),
        questionWords: questionWords,
        categoryWords: categoryWords,
        answerWords: answerWords,
        allWords: questionWords.concat(categoryWords, answerWords),
        order: numericOrder(item),
        sourceIndex: index
      };
    });

    var categoryById = {};
    categories.forEach(function (category) {
      if (category.id) categoryById[category.id] = category;
    });

    var navByCategoryId = {};
    navLinks.forEach(function (link) {
      var href = link.getAttribute('href') || '';
      if (href.charAt(0) === '#') navByCategoryId[href.slice(1)] = link;
    });

    function defaultStatus() {
      return pluralize(entries.length, 'question', 'questions') + ' across ' +
        pluralize(categories.length, 'topic', 'topics') + '.';
    }

    function searchScore(entry, normalizedQuery, queryWords) {
      if (!queryWords.length) return Number.MAX_SAFE_INTEGER;
      if (entry.questionNormalized === normalizedQuery) return 0;
      if (hasWordPrefixes(entry.questionWords, queryWords)) return 1;
      if (hasWordPrefixes(entry.categoryWords, queryWords)) return 2;
      if (hasWordPrefixes(entry.allWords, queryWords)) return 3;
      return Number.MAX_SAFE_INTEGER;
    }

    function matchingEntries(rawQuery) {
      var normalizedQuery = normalizeText(rawQuery);
      var queryWords = normalizedQuery ? normalizedQuery.split(' ') : [];

      if (!queryWords.length) return [];

      return entries
        .map(function (entry) {
          return {
            entry: entry,
            score: searchScore(entry, normalizedQuery, queryWords)
          };
        })
        .filter(function (match) {
          return match.score !== Number.MAX_SAFE_INTEGER;
        })
        .sort(function (first, second) {
          if (first.score !== second.score) return first.score - second.score;
          if (first.entry.order !== second.entry.order) return first.entry.order - second.entry.order;
          var questionOrder = first.entry.question.localeCompare(second.entry.question);
          return questionOrder || first.entry.sourceIndex - second.entry.sourceIndex;
        })
        .map(function (match) {
          return match.entry;
        });
    }

    function setSearchOpen(isOpen) {
      if (!searchInput || !searchResults) return;
      searchResults.hidden = !isOpen;
      searchInput.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      if (!isOpen) {
        activeResultIndex = -1;
        searchInput.removeAttribute('aria-activedescendant');
        resultButtons.forEach(function (button) {
          button.setAttribute('aria-selected', 'false');
        });
      }
    }

    function setActiveResult(nextIndex) {
      if (!resultButtons.length || !searchInput) {
        activeResultIndex = -1;
        return;
      }

      activeResultIndex = (nextIndex + resultButtons.length) % resultButtons.length;

      resultButtons.forEach(function (button, index) {
        button.setAttribute('aria-selected', index === activeResultIndex ? 'true' : 'false');
      });

      var activeButton = resultButtons[activeResultIndex];
      searchInput.setAttribute('aria-activedescendant', activeButton.id);
      activeButton.scrollIntoView({ block: 'nearest' });
    }

    function anchorOffset() {
      var offset = stickyTop + varSpace(16);
      if (tabletLayout.matches && topicIndex) offset += topicIndex.offsetHeight;
      return offset;
    }

    function varSpace(fallback) {
      return fallback;
    }

    function scrollToTarget(target, forcedBehavior) {
      if (!target) return;
      var top = target.getBoundingClientRect().top + window.pageYOffset - anchorOffset();
      var behavior = forcedBehavior || (reduceMotion.matches ? 'auto' : 'smooth');
      window.scrollTo({ top: Math.max(0, Math.round(top)), behavior: behavior });
    }

    function replaceHash(target) {
      if (!target || !target.id || !window.history || !window.history.replaceState) return;
      window.history.replaceState(null, '', '#' + target.id);
    }

    function selectEntry(entry) {
      if (!entry) return;

      setSearchOpen(false);
      entry.item.open = true;
      replaceHash(entry.item);

      window.requestAnimationFrame(function () {
        scrollToTarget(entry.item);
        if (entry.questionNode) {
          try {
            entry.questionNode.focus({ preventScroll: true });
          } catch (error) {
            entry.questionNode.focus();
          }
        }
      });
    }

    function makeResultButton(entry, index) {
      var button = document.createElement('button');
      var categoryLabel = document.createElement('span');
      var questionLabel = document.createElement('span');

      button.type = 'button';
      button.id = root.id + '-search-result-' + index;
      button.className = 'cz-faq-search__result';
      button.setAttribute('role', 'option');
      button.setAttribute('aria-selected', 'false');
      categoryLabel.className = 'cz-faq-search__result-category';
      questionLabel.className = 'cz-faq-search__result-question';
      categoryLabel.textContent = entry.category;
      questionLabel.textContent = entry.question;
      button.appendChild(categoryLabel);
      button.appendChild(questionLabel);

      button.addEventListener('pointerenter', function () {
        setActiveResult(index);
      });
      button.addEventListener('click', function () {
        selectEntry(entry);
      });

      return button;
    }

    function renderEmptyState() {
      var empty = document.createElement('div');
      var message = document.createElement('p');
      var reset = document.createElement('button');

      empty.className = 'cz-faq-search__empty';
      message.textContent = 'No matching questions. Try another word or browse by topic.';
      reset.type = 'button';
      reset.className = 'cz-faq-search__empty-clear';
      reset.textContent = 'Clear search';
      empty.appendChild(message);
      empty.appendChild(reset);
      searchResults.appendChild(empty);

      reset.addEventListener('click', clearSearch);
    }

    function setResultsSemantics(isListbox) {
      if (!searchResults || !searchInput) return;

      if (isListbox) {
        searchResults.setAttribute('role', 'listbox');
        searchInput.setAttribute('aria-haspopup', 'listbox');
      } else {
        searchResults.removeAttribute('role');
        searchInput.removeAttribute('aria-haspopup');
        searchInput.removeAttribute('aria-activedescendant');
      }
    }

    function renderSearch() {
      if (!searchInput || !searchResults || !searchStatus || !clearButton) return;

      var rawQuery = searchInput.value;
      var normalizedQuery = normalizeText(rawQuery);
      var trimmedQuery = rawQuery.trim();
      clearButton.hidden = rawQuery.length === 0;
      searchResults.replaceChildren();
      resultButtons = [];
      currentMatches = [];
      activeResultIndex = -1;
      searchInput.removeAttribute('aria-activedescendant');

      if (!normalizedQuery) {
        setResultsSemantics(true);
        searchStatus.textContent = defaultStatus();
        setSearchOpen(false);
        return;
      }

      currentMatches = matchingEntries(rawQuery);
      searchStatus.textContent = pluralize(currentMatches.length, 'result', 'results') +
        ' for “' + trimmedQuery + '”.';

      if (!currentMatches.length) {
        setResultsSemantics(false);
        renderEmptyState();
        setSearchOpen(true);
        return;
      }

      setResultsSemantics(true);
      currentMatches.forEach(function (entry, index) {
        var button = makeResultButton(entry, index);
        resultButtons.push(button);
        searchResults.appendChild(button);
      });

      setSearchOpen(true);
    }

    function clearSearch() {
      if (!searchInput) return;
      searchInput.value = '';
      renderSearch();
      searchInput.focus();
    }

    function onSearchKeydown(event) {
      if (!searchResults || searchResults.hidden) return;

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        setActiveResult(activeResultIndex + 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        setActiveResult(activeResultIndex < 0 ? resultButtons.length - 1 : activeResultIndex - 1);
      } else if (event.key === 'Home' && resultButtons.length) {
        event.preventDefault();
        setActiveResult(0);
      } else if (event.key === 'End' && resultButtons.length) {
        event.preventDefault();
        setActiveResult(resultButtons.length - 1);
      } else if (event.key === 'Enter' && currentMatches.length) {
        event.preventDefault();
        selectEntry(currentMatches[activeResultIndex < 0 ? 0 : activeResultIndex]);
      } else if (event.key === 'Escape') {
        event.preventDefault();
        setSearchOpen(false);
      }
    }

    function visibleHeaderBottom() {
      var selectors = [
        '#shopify-section-announcement-bar',
        '[id*="shopify-section-announcement"]',
        '#shopify-section-header',
        '[id*="shopify-section-header"]',
        '#pageheader',
        '.section-header',
        '.announcement-bar',
        '.header-wrapper',
        'sticky-header',
        '[data-header-section]'
      ];
      var candidates = [];

      selectors.forEach(function (selector) {
        Array.prototype.slice.call(document.querySelectorAll(selector)).forEach(function (candidate) {
          if (candidates.indexOf(candidate) === -1 && !root.contains(candidate)) candidates.push(candidate);
        });
      });

      return candidates.reduce(function (bottom, candidate) {
        var style = window.getComputedStyle(candidate);
        var rect = candidate.getBoundingClientRect();
        var isVisible = style.display !== 'none' && style.visibility !== 'hidden' && rect.height > 0;
        var isNearTop = rect.bottom > 0 && rect.top < Math.min(200, window.innerHeight / 3);
        var isReasonableHeight = rect.bottom < window.innerHeight / 2;

        return isVisible && isNearTop && isReasonableHeight ? Math.max(bottom, rect.bottom) : bottom;
      }, 0);
    }

    function updateStickyTop() {
      var headerBottom = Math.ceil(visibleHeaderBottom());
      var stickyGap = tabletLayout.matches ? 0 : 24;
      var minimumTop = tabletLayout.matches ? 0 : 24;
      var nextTop = Math.min(240, Math.max(minimumTop, headerBottom + stickyGap));
      if (nextTop === stickyTop) return;
      stickyTop = nextTop;
      root.style.setProperty('--cz-faq-sticky-top', stickyTop + 'px');
    }

    function centerActiveNavLink(link) {
      if (!topicNav || !link || !tabletLayout.matches) return;

      var targetLeft = link.offsetLeft - ((topicNav.clientWidth - link.offsetWidth) / 2);
      topicNav.scrollTo({
        left: Math.max(0, targetLeft),
        behavior: reduceMotion.matches ? 'auto' : 'smooth'
      });
    }

    function setActiveCategory(categoryId) {
      if (!categoryId || categoryId === activeCategoryId) return;
      activeCategoryId = categoryId;

      navLinks.forEach(function (link) {
        var isCurrent = link === navByCategoryId[categoryId];
        if (isCurrent) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });

      centerActiveNavLink(navByCategoryId[categoryId]);
    }

    function updateScrollSpy() {
      if (!categories.length) return;

      var marker = window.pageYOffset + anchorOffset() + 24;
      var activeCategory = categories[0];

      categories.forEach(function (category) {
        var categoryTop = category.getBoundingClientRect().top + window.pageYOffset;
        if (categoryTop <= marker) activeCategory = category;
      });

      setActiveCategory(activeCategory.id);
    }

    function updateViewportState() {
      viewportFrame = 0;
      updateStickyTop();
      updateScrollSpy();
    }

    function scheduleViewportUpdate() {
      if (viewportFrame) return;
      viewportFrame = window.requestAnimationFrame(updateViewportState);
    }

    function onNavClick(event) {
      var link = event.currentTarget;
      var href = link.getAttribute('href') || '';
      var category = href.charAt(0) === '#' ? categoryById[href.slice(1)] : null;
      if (!category) return;

      event.preventDefault();
      setSearchOpen(false);
      setActiveCategory(category.id);
      replaceHash(category);
      scrollToTarget(category);
    }

    if (searchInput && searchResults && searchStatus && clearButton) {
      searchInput.setAttribute('role', 'combobox');
      searchInput.setAttribute('aria-autocomplete', 'list');
      searchInput.setAttribute('aria-haspopup', 'listbox');
      searchStatus.textContent = defaultStatus();
      clearButton.hidden = searchInput.value.length === 0;

      listen(searchInput, 'input', renderSearch);
      listen(searchInput, 'keydown', onSearchKeydown);
      listen(searchInput, 'focus', function () {
        if (normalizeText(searchInput.value)) renderSearch();
      });
      listen(clearButton, 'click', clearSearch);
      listen(searchForm, 'submit', function (event) {
        event.preventDefault();
        if (currentMatches.length) selectEntry(currentMatches[activeResultIndex < 0 ? 0 : activeResultIndex]);
      });
      listen(document, 'pointerdown', function (event) {
        if (searchForm && !searchForm.contains(event.target)) setSearchOpen(false);
      });
    }

    navLinks.forEach(function (link) {
      listen(link, 'click', onNavClick);
    });

    listen(window, 'scroll', scheduleViewportUpdate, { passive: true });
    listen(window, 'resize', scheduleViewportUpdate, { passive: true });
    listen(window, 'orientationchange', scheduleViewportUpdate, { passive: true });

    if (typeof reduceMotion.addEventListener === 'function') {
      listen(reduceMotion, 'change', scheduleViewportUpdate);
      listen(tabletLayout, 'change', scheduleViewportUpdate);
    } else {
      reduceMotion.addListener(scheduleViewportUpdate);
      tabletLayout.addListener(scheduleViewportUpdate);
      cleanupTasks.push(function () {
        reduceMotion.removeListener(scheduleViewportUpdate);
        tabletLayout.removeListener(scheduleViewportUpdate);
      });
    }

    var resizeObserver = null;
    if (typeof window.ResizeObserver === 'function') {
      resizeObserver = new window.ResizeObserver(scheduleViewportUpdate);
      resizeObserver.observe(document.documentElement);
      if (topicIndex) resizeObserver.observe(topicIndex);
      cleanupTasks.push(function () {
        resizeObserver.disconnect();
      });
    }

    function alignInitialHash() {
      if (!window.location.hash) return;

      var targetId;
      try {
        targetId = decodeURIComponent(window.location.hash.slice(1));
      } catch (error) {
        targetId = window.location.hash.slice(1);
      }

      var target = document.getElementById(targetId);
      if (!target || !root.contains(target)) return;

      var item = target.matches(ITEM_SELECTOR) ? target : target.closest(ITEM_SELECTOR);
      if (item) item.open = true;

      window.requestAnimationFrame(function () {
        updateStickyTop();
        scrollToTarget(target, 'auto');
      });
    }

    updateViewportState();
    window.setTimeout(alignInitialHash, 0);

    listen(document, 'shopify:section:unload', function (event) {
      if (!event.target || !event.target.contains(root)) return;
      cleanupTasks.splice(0).forEach(function (cleanup) {
        cleanup();
      });
      root.removeAttribute('data-cz-faq-initialized');
    });
  }

  function initAll(scope) {
    var searchScope = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.slice.call(searchScope.querySelectorAll(ROOT_SELECTOR)).forEach(initFaq);

    if (searchScope.matches && searchScope.matches(ROOT_SELECTOR)) initFaq(searchScope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
